import './style/index.js';

import _Popconfirm from './Popconfirm';

export type { PopconfirmProps } from './Popconfirm';
export * from './type';

export const Popconfirm = _Popconfirm;
export default Popconfirm;
